var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    className: "image_svg__design-iconfont"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.833 4.183c.456 0 .868.185 1.167.484.299.298.483.71.483 1.166v8.334c0 .455-.184.868-.483 1.166a1.645 1.645 0 0 1-1.167.484H4.167c-.456 0-.868-.185-1.167-.484a1.645 1.645 0 0 1-.483-1.166V5.833c0-.455.184-.868.483-1.166a1.645 1.645 0 0 1 1.167-.484Z",
    stroke: "#696F7F",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.213 13.333a.63.63 0 0 1-.545-.315.663.663 0 0 1 .22-.878l3.36-2.207a.714.714 0 0 1 .779-.005l1.788 1.144a.357.357 0 0 0 .395-.007l3.225-2.205a.625.625 0 0 1 .889.19c.184.297.083.692-.204.889l-3.691 2.524a.714.714 0 0 1-.79.013l-1.798-1.15a.357.357 0 0 0-.39.002L5.557 13.23a.623.623 0 0 1-.343.103Z",
    stroke: "#696F7F",
    strokeWidth: 0.5,
    fill: "#696F7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.356 7.901a1.042 1.042 0 1 0 2.083 0 1.042 1.042 0 0 0-2.083 0Z",
    fill: "#696F7F",
    fillRule: "nonzero"
  }))));
};
export default SvgImage;